export default __webpack_public_path__ + "static/media/svg-5.1d0b6ff8.svg";